import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { E } from '@angular/core/src/render3';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-with-ulip',
  templateUrl: './add-with-ulip.component.html',
  styleUrls: ['./add-with-ulip.component.scss']
})
export class AddWithULIPComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() UlipType: any;
  @Output() onSaveUlip = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  TenantId: any;
  CompanyId: any;
  userId: any;
  data: any = {};
  RegistrationNo: any = {
    lable: 'Registration No',
    formControlName: 'RegistrationNo',
    dataField: 'RegistrationNo',
    isRequired: false,
    placeholder: 'Enter Registration No',
  };
  LicenseNo: any = {
    lable: 'License No',
    formControlName: 'LicenseNo',
    dataField: 'LicenseNo',
    isRequired: false,
    placeholder: 'Enter License No',
  };
  DOB = {
    lable: 'Date Of Birth',
    formControlName: 'DOB',
    dataField: 'DOB',
    isRequired: false,
    placeholder: 'Select Date Of Birth',
  };
  // Added by priya - 24/03/2026 - cn(PRIYA-MAR26-0010)
  GSTNo: any = {
    lable: 'GST No',
    formControlName: 'GSTNo',
    dataField: 'GSTNo',
    isRequired: false,
    type: 'text',
    maxInputLength: 15,
    placeholder: 'Enter GST No',
  };
  // End by priya

  isMobileView: any;

  constructor(
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if(this.UlipType == 'Vehicle'){
      this.RegistrationNo.isRequired = true;
    } else {
      this.RegistrationNo.isRequired = false;
    }
    if(this.UlipType == 'Driver'){
      this.LicenseNo.isRequired = true;
      this.DOB.isRequired = true;
    } else {
      this.LicenseNo.isRequired = false;
      this.DOB.isRequired = false;
    }
    // Added by priya - 24/03/2026 - cn(PRIYA-MAR26-0010)
    if(this.UlipType == 'Network'){
      this.GSTNo.isRequired = true;
    } else{
      this.GSTNo.isRequired = false;
    }
    // End by priya
  }

  getChangedValue(value, data) {
    // if(data.dataField == 'DOB'){
    //   const date = new Date(value);
    //   const yyyy = date.getFullYear();
    //   const mm = String(date.getMonth() + 1).padStart(2, '0');
    //   const dd = String(date.getDate()).padStart(2, '0');
    //   this.data[data.dataField] = `${yyyy}-${mm}-${dd}`;
    // } else {
      this.data[data.dataField] = value;
    // }
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if(this.UlipType == 'Vehicle'){
      if (!this.data.RegistrationNo) {
        IsAllDataDone = false;
      }
    }
    if(this.UlipType == 'Driver'){
      if (!this.data.LicenseNo) {
        IsAllDataDone = false;
      }
      if (!this.data.DOB) {
        IsAllDataDone = false;
      }
    }
    // Added by priya - 24/03/2026 - cn(PRIYA-MAR26-0010)
    if (this.UlipType == 'Network') {
      if (!this.data.GSTNo || this.data.GSTNo.trim() === '') {
        IsAllDataDone = false;
      } else if (!this.validateGSTNumber(this.data.GSTNo || this.data.GSTNo.trim())) {
        IsAllDataDone = false;
        this.toastr.warning('Invalid GST number format');
      }
    }
    // End by priya
    return IsAllDataDone;
  }

  onclose() {
    this.onCloseEvent.emit();
  }

  OnSave() {
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      this.onSaveUlip.emit(this.data);
    }
  }

  // Added by priya - 25/03/2026 - cn(PRIYA-MAR26-0010)
  validateGSTNumber(gstNumber) {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gstNumber);
  }

}
